import {http} from 'lib/httpAxios'

export default {
  retrieveDashboardData (data) {
    var url = `/dashboard/${data.client.code}/${data.startDate}/${data.endDate}`
    return http.get(url)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  }
}



// WEBPACK FOOTER //
// ./src/vuex/api/services/dashboard.js